import { EventEmitter } from 'events';
import dispatcher from 'dispatcher';
//import * as Strings from '../../utils/strings';
import * as actionConstants from 'utils/ActionConstants';
import sessionManager from 'utils/managers/sessionManager';

class OnboardingStore extends EventEmitter {
    constructor() {
        super();
        this.loginState = { loading: false };
        this.signUpState = { loading: false };
    }
    getLoginState = () => {
        return this.loginState;
    };
    getSignUpState = () => {
        return this.signUpState;
    };

    handleActions = action => {
        switch (action.type) {
            case actionConstants.LOGIN: {
                this.loginState = { loading: true };
                this.emit('change');
                break;
            }
            case actionConstants.LOGIN_FAILURE: {
                this.loginState = { loading: false };
                this.emit('change');
                break;
            }
            case actionConstants.SIGN_UP: {
                this.signUpState = { loading: true };
                this.emit('change');
                break;
            }
            case actionConstants.SIGN_UP_FAILURE: {
                this.signUpState = { loading: false };
                this.emit('change');
                break;
            }
        }
    };
}

const onboardingStore = new OnboardingStore();

dispatcher.register(onboardingStore.handleActions);

export default onboardingStore;



// WEBPACK FOOTER //
// ./src/modules/onboarding/OnboardingStore.js